/* global window */

const CHANNEL_GRANT_TOKEN_STORAGE_KEY = 'dativery-channel-grant-token';

export function saveChannelGrantToken(token) {
    if (!token) {
        return;
    }

    try {
        if (window && window.sessionStorage) {
            window.sessionStorage.setItem(CHANNEL_GRANT_TOKEN_STORAGE_KEY, token);
        }
    } catch (e) {
        // Some embedded/browser contexts block sessionStorage; the normal stored token still works there.
    }
}

export function consumeChannelGrantToken() {
    try {
        if (window && window.sessionStorage) {
            const token = window.sessionStorage.getItem(CHANNEL_GRANT_TOKEN_STORAGE_KEY);
            window.sessionStorage.removeItem(CHANNEL_GRANT_TOKEN_STORAGE_KEY);
            return token;
        }
    } catch (e) {
        // Ignore storage access failures and fall back to the regular token sources.
    }

    return null;
}
